// extracted by mini-css-extract-plugin
export default {"list":"Accounts_list__wMFH4"};